(function () {
  function initPebbleFaq(section) {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    if (section.dataset.singleOpen !== 'true') return;

    const items = section.querySelectorAll('.pebble-faq__item');
    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((other) => {
          if (other !== item) other.open = false;
        });

        const accordion = item.closest('.pebble-faq__accordion');
        if (accordion) {
          requestAnimationFrame(() => {
            const accordionTop = accordion.getBoundingClientRect().top;
            const itemTop = item.getBoundingClientRect().top;
            const itemBottom = item.getBoundingClientRect().bottom;
            const accordionBottom = accordion.getBoundingClientRect().bottom;

            if (itemBottom > accordionBottom) {
              accordion.scrollTop += itemBottom - accordionBottom + 8;
            } else if (itemTop < accordionTop) {
              accordion.scrollTop += itemTop - accordionTop - 8;
            }
          });
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('.pebble-faq[data-single-open]').forEach(initPebbleFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.pebble-faq');
    if (section) initPebbleFaq(section);
  });
})();
